import { createAction } from '@reduxjs/toolkit';
import { IOrderCounter } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_ORDER_COUNTERS } from '../../../../common';

export const setOrderCounters = createAction<IOrderCounter[]>(
  `${MN_ORDER_COUNTERS}/${TYPE_LIST}/${ACT_SET}`,
);
